"use client";
import { useContext, useEffect, useState } from "react";
import { icons } from "./icons";
import { AppContext } from "./AppContext";
import Button from "./Button";

export default function History({ cl }) {
  const { config, bg, setConfig, setBg } = useContext(AppContext);
  const [c, setC] = useState([]);
  const [curStep, setCurStep] = useState(0);

  useEffect(() => {
    const newC = [...c];
    const date = Date.now();
    const findOb = newC.find(({ config: oldConfig, bg: oldBg }) => {
      return oldConfig === config && oldBg === bg;
    });

    if (findOb) setCurStep(c.indexOf(findOb));

    if (!newC[0] || (!findOb && newC[0].date < date - 1000)) {
      newC.unshift({ date, config, bg });
      setC(newC);
    }
  }, [config, bg, c]);

  const load = (idx) => {
    const destination = c[curStep + idx];
    if (destination) {
      setConfig(destination.config);
      setBg(destination.bg);
      setCurStep(curStep + idx);
    }
  };

  const getCl = (idx) => {
    const destination = c[curStep + idx];

    return !destination ? "opacity-20 pointer-events-none" : "cursor-pointer";
  };

  return (
    <>
      {/* <div className="fixed bg-black text-white p-5 left-0 top-0 w-[500px]">
         {c.map((k,i)=><div className={(i === curStep) ? 'bg-red-500' : 'border'} onClick={()=>{
        
        const {bg,config} = k
        setConfig(config)
        setBg(bg)
        
    }} key={i}>{k.date}</div>)}
    </div>
     */}
      <>
        <Button className={cl} onClick={() => load(1)}>
          <div className={getCl(1)}>{icons.prev}</div>
        </Button>
        <Button className={cl} onClick={() => load(-1)}>
          <div className={getCl(-1)}>{icons.next}</div>
        </Button>
      </>
    </>
  );
}
